import { Container, Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import Breadcrumb from '../../components/Breadcrumb';
import Preloader from '../../components/PreLoader';
import staff from '../../models/staff.model';
import { fetchStaffsByID } from '../../services/staff.service';

interface params{
  id:string
}

const MemberDetails:React.FC = ()=>{

  const {id} = useParams<params>();

  const [member,setmember] = React.useState<staff|undefined>(undefined);
  const [loading,setLoading] = React.useState(false);

  const fetchStaffByid = async()=>{
    setLoading(true);
    const response = await fetchStaffsByID(id);
    setmember(response);
    setLoading(false);
  }

  useEffect(()=>{
    fetchStaffByid()
  },[id]) //eslint-disable-line

  return(
    <>
    <Breadcrumb routes={[{title:member?member.name:''}]}/>
    <Container maxWidth="lg">
      {loading?<Preloader/>:
      <Grid container className="section-padding-2">
        {member?
        <Grid item xs={12}>
          <div className="text-center">
            {member.image?
            <img src={member.image} alt="" className="mb-05" style={{width:'300px',maxWidth:'100%'}}/>
            :''}
            <h4 className="text-18-primary text-center mb-05">{member.name}</h4>
            <p className="text-12 text-center">{member.designation}</p>
          </div>
          <div className="section-break-2">
          <div className="blog-details" dangerouslySetInnerHTML={{ __html: member.bio|| '' }}>
               </div>
          </div>
        </Grid>
        :
          <h3 className="text-primary text-center">Sorry member not found!!</h3>
        }
      </Grid>
      }
    </Container>
    </>
  );
}

export default MemberDetails;